import React from "react";
import { useChat } from "./ChatContext";
import { GeminiStar } from "./GeminiStar";

export default function ChatToggleButton() {
  const { toggle, open } = useChat();

  return (
    <button
      onClick={toggle}
      className={`theme-toggle${open ? " active" : ""}`}
      aria-label="Toggle NotGemini chat"
      title="NotGemini"
    >
      <GeminiStar size={20} />
    </button>
  );
}
